import gql from 'graphql-tag';

export const SESSION_USER_FIELDS = gql`
  fragment SessionUserFields on User {
    id
    brazeExternalId
    createdAt
    email
    firstName
    lastName
    birthYear
    howHeardAbout
    billingRegion
    homeCity {
      id
      title
      cachedSlug
      aliases
      country {
        id
        countryCode
        title
      }
    }
    locale
    mobile {
      countryCodeIso3166
      numberBody
    }
    isArtist
    isInternal
    isGuest
    visitorType
    acknowledgedGdprAgreementAt
    acknowledgedCuratorAgreementAt
    acknowledgedCuratorAgreement2At
    acknowledgedCuratorAgreement3At
    declinedCuratorAgreement2At
    shouldPromptForEmailMarketing
    shouldPromptForSmsMarketing
    __typename
  }
`;

export const GET_SESSION = gql`
  query GetSession {
    session {
      user {
        ...SessionUserFields
      }
      loggedIn
      magicTokenAuthentication
      userIpGeolocation {
        latitude
        longitude
        countryCode
        continentCode
        geoIpDataStoredAt
      }
      message
      messageMoreInfoLink
      messageMoreInfoText
      visa {
        cardId
        cardLast4
        eligible
        eligibilityLevel
        visaVerifiedAt
        expiresAt
        cardType
        isGlobalOffer
        countryCodeIso31661Numeric
        visaBannerMessageDismissedAt
      }
      visitorType
      closestCitiesCache {
        closestCityIds
        closestCitiesStoredAt
      }
    }
  }
  ${SESSION_USER_FIELDS}
`;

export const GET_SESSION_WITH_PERMISSIONS = gql`
  query GetSessionWithPermissions($permissionContexts: [String]) {
    session(permissionContexts: $permissionContexts) {
      user {
        ...SessionUserFields
      }
      loggedIn
      magicTokenAuthentication
      userIpGeolocation {
        latitude
        longitude
        countryCode
        continentCode
        geoIpDataStoredAt
      }
      message
      messageMoreInfoLink
      messageMoreInfoText
      visa {
        cardId
        cardLast4
        eligible
        eligibilityLevel
        visaVerifiedAt
        expiresAt
        cardType
        isGlobalOffer
        countryCodeIso31661Numeric
        visaBannerMessageDismissedAt
      }
      visitorType
      closestCitiesCache {
        closestCityIds
        closestCitiesStoredAt
      }
      permissions {
        name
        resourceId
        resourceType
        associatedObjectResourceId
        associatedObjectResourceType
        resourceExtraData {
          organizerGroupType
        }
      }
      shouldPromptForOrganizerSurvey
    }
  }
  ${SESSION_USER_FIELDS}
`;
